module.exports = __webpack_public_path__ + "img/logo.6809c367.png";